module.exports = __webpack_public_path__ + "static/img/member-1.c38c5d0b.png";